(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mgpd-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mgpdInit) return;
    window.__mgpdInit = true;

    var root = document.documentElement;

    function headerTheme() {
      var x = Math.round(window.innerWidth * 0.08);
      var y = 28;
      var els = document.elementsFromPoint ? document.elementsFromPoint(x, y) : [];
      var theme = 'dark';
      var solid = false;
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (el.closest('.shopify-section--header')) continue;
        var sec = el.closest('.shopify-section');
        if (!sec) continue;
        var t = sec.querySelector('[data-mgpd-theme]');
        theme = sec.classList.contains('mgpd-panel') && t ? t.getAttribute('data-mgpd-theme') : 'dark';
        /* Banner uzerinde header seffaf kalir. Urun izgarasi ve diger bolumlerde beyaz zemin alir, logo urunlerin ustune binmez */
        solid = !sec.classList.contains('mgpd-panel--banner');
        break;
      }
      root.classList.toggle('mgpd-hdr-light', theme === 'light');
      root.classList.toggle('mgpd-hdr-solid', solid);
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        headerTheme();
        updateVideos();
      });
    }

    var mq = window.matchMedia('(max-width: 699px)');
    var vids = [];

    function srcFor(v) { return mq.matches && v.dataset.mgpdM ? v.dataset.mgpdM : v.dataset.mgpdD; }

    function ensureSrc(v) {
      var src = srcFor(v);
      if (!src || v.dataset.mgpdCur === src) return;
      v.dataset.mgpdCur = src;
      v.classList.remove('is-playing');
      v.preload = 'auto';
      v.src = src;
      v.load();
    }

    /* Paneller ust uste yapisik durur. Ust panel tamamen ortuldugunde video durur, sadece gorunen oynar */
    function updateVideos() {
      var vh = window.innerHeight;
      for (var i = 0; i < vids.length; i++) {
        var v = vids[i];
        var sec = v.__sec;
        var r = sec.getBoundingClientRect();
        var next = sec.nextElementSibling;
        var covered = false;
        if (next) {
          var nr = next.getBoundingClientRect();
          covered = nr.top <= 0 && nr.height >= vh * 0.9;
        }
        var visible = r.bottom > 0 && r.top < vh && !covered;
        var near = r.top < vh * 2 && r.bottom > -vh;
        if (near || visible) ensureSrc(v);
        if (visible) {
          if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        } else if (!v.paused) {
          v.pause();
        }
      }
    }

    function setupVideos(scope) {
      (scope || document).querySelectorAll('video[data-mgpd-d]').forEach(function (v) {
        if (v.__mgpd) return;
        v.__mgpd = true;
        v.muted = true;
        v.__sec = v.closest('.shopify-section') || v.parentNode;
        v.addEventListener('playing', function () { v.classList.add('is-playing'); });
        vids.push(v);
      });
      updateVideos();
    }

    if (mq.addEventListener) mq.addEventListener('change', updateVideos);
    else if (mq.addListener) mq.addListener(updateVideos);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) vids.forEach(function (v) { if (!v.paused) v.pause(); });
      else updateVideos();
    });

    function init() {
      if (!document.querySelector('.mgpd-panel')) return;
      setupVideos(document);
      headerTheme();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    document.addEventListener('shopify:section:load', function (e) { setupVideos(e.target); headerTheme(); });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    window.addEventListener('load', headerTheme);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mgpd-cart"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mgpdCartJs) return;
    window.__mgpdCartJs = true;

    function root() { return document.querySelector('[data-mgpd-cart]'); }

    function refresh(r) {
      var sid = r.getAttribute('data-section-id');
      return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sid), { credentials: 'same-origin' })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var n = doc.querySelector('[data-mgpd-cart]');
          if (n) r.innerHTML = n.innerHTML;
          r.classList.remove('is-busy');
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if (window.__mgpdMark) r.querySelectorAll('.mgpd-cart__img').forEach(window.__mgpdMark);
          if (window.__mgpdColInit) window.__mgpdColInit(r);
        })
        .catch(function () { window.location.reload(); });
    }

    function change(key, q) {
      var r = root();
      if (!r) return;
      r.classList.add('is-busy');
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, q) })
      })
        .then(function (res) { return res.json(); })
        .then(function () { return refresh(r); })
        .catch(function () { window.location.reload(); });
    }

    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-mgpd-cart] [data-mgpd-qty]');
      if (!a) return;
      var row = a.closest('[data-key]');
      if (!row) return;
      e.preventDefault();
      change(row.getAttribute('data-key'), parseInt(a.getAttribute('data-mgpd-qty'), 10) || 0);
    });

    document.addEventListener('change', function (e) {
      var i = e.target.closest('[data-mgpd-cart] [data-mgpd-qty-input]');
      if (!i) return;
      var row = i.closest('[data-key]');
      var v = parseInt(i.value, 10);
      if (!row || isNaN(v)) return;
      change(row.getAttribute('data-key'), v);
    });

    /* Oneri kartindan sepete eklenince sayfadaki liste de yenilenir */
    document.addEventListener('variant:add', function () {
      var r = root();
      if (r) setTimeout(function () { refresh(r); }, 300);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mgpd-chrome"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mgpdChrome) return;
    window.__mgpdChrome = true;

    function on() { return !!document.querySelector('.mgpd-chrome'); }

    /* Menu: PDPAOLA duzenindeki linkler ve gorsel kartlar */
    function injectMenu() {
      var side = document.querySelector('header-sidebar');
      var tpl = document.getElementById('mgpd-menu-tpl');
      if (!side || !tpl) return;
      var scroller = side.querySelector('.header-sidebar__main-panel > .header-sidebar__scroller');
      if (!scroller || scroller.querySelector('.mgpd-menu')) return;
      scroller.appendChild(tpl.content.cloneNode(true));
    }

    /* V10: Masaustu ust menu. Basliga gelince veya tiklayinca fotografli panel acilir */
    var dd = { open: null, timer: 0, y: 0 };
    var mqDesk = window.matchMedia('(min-width: 1000px)');

    function ddTop() {
      var h = document.querySelector('.shopify-section--header x-header') || document.querySelector('.shopify-section--header .header');
      var b = h ? Math.max(0, Math.round(h.getBoundingClientRect().bottom)) : 90;
      document.documentElement.style.setProperty('--mgpd-dd-top', b + 'px');
    }

    function ddSet(key) {
      var root = document.documentElement;
      if (key && !mqDesk.matches) key = null;
      if (dd.open === key) return;
      dd.open = key;
      document.querySelectorAll('.mgpd-dnav__item[data-dd]').forEach(function (b) {
        b.setAttribute('aria-expanded', b.getAttribute('data-dd') === key ? 'true' : 'false');
      });
      document.querySelectorAll('.mgpd-dd[data-dd-panel]').forEach(function (p) {
        p.hidden = p.getAttribute('data-dd-panel') !== key;
      });
      if (key) {
        ddTop();
        dd.y = window.scrollY;
        root.classList.add('mgpd-dd-open');
        requestAnimationFrame(ddTop);
      } else {
        root.classList.remove('mgpd-dd-open');
      }
    }

    function ddLater(key, ms) {
      clearTimeout(dd.timer);
      dd.timer = setTimeout(function () { ddSet(key); }, ms);
    }

    function injectDnav() {
      var tpl = document.getElementById('mgpd-dnav-tpl');
      var nav = document.querySelector('.shopify-section--header .header__primary-nav');
      if (!tpl || !nav || nav.querySelector('.mgpd-dnav')) return;
      var frag = tpl.content.cloneNode(true);
      var bar = frag.querySelector('.mgpd-dnav');
      var layer = frag.querySelector('.mgpd-dd-layer');
      if (!bar || !layer) return;
      var here = location.pathname.replace(/\/$/, '');
      bar.querySelectorAll('a.mgpd-dnav__item').forEach(function (a) {
        var u = (a.getAttribute('href') || '').split('?')[0].replace(/\/$/, '');
        if (u && u === here) a.setAttribute('aria-current', 'page');
      });
      nav.appendChild(bar);
      var old = document.querySelector('body > .mgpd-dd-layer');
      if (old) old.remove();
      document.body.appendChild(layer);

      var hover = window.matchMedia('(hover: hover)').matches;
      /* Panel gorselleri menuye ilk yaklasildiginda onceden yuklenir, panel aninda dolu acilir */
      var warm = function () {
        bar.removeEventListener('pointerenter', warm);
        layer.querySelectorAll('.mgpd-dd img').forEach(function (img) {
          var i = new Image();
          if (img.sizes) i.sizes = img.sizes;
          if (img.srcset) i.srcset = img.srcset;
          i.src = img.src;
        });
      };
      bar.addEventListener('pointerenter', warm);
      bar.querySelectorAll('.mgpd-dnav__item').forEach(function (it) {
        var key = it.getAttribute('data-dd');
        if (hover) {
          it.addEventListener('mouseenter', function () { ddLater(key || null, dd.open ? 40 : 90); });
          it.addEventListener('mouseleave', function () { ddLater(null, 300); });
        }
        if (key) {
          it.addEventListener('click', function (e) {
            e.preventDefault();
            clearTimeout(dd.timer);
            ddSet(dd.open === key && !hover ? null : key);
          });
        }
      });
      layer.querySelectorAll('.mgpd-dd').forEach(function (p) {
        if (hover) {
          p.addEventListener('mouseenter', function () { clearTimeout(dd.timer); });
          p.addEventListener('mouseleave', function () { ddLater(null, 300); });
        }
        p.addEventListener('click', function (e) { if (e.target.closest('a')) ddSet(null); });
      });
      var veil = layer.querySelector('[data-mgpd-dd-veil]');
      if (veil) veil.addEventListener('click', function () { ddSet(null); });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !dd.open) return;
      var b = document.querySelector('.mgpd-dnav__item[data-dd="' + dd.open + '"]');
      ddSet(null);
      if (b) b.focus();
    });
    window.addEventListener('scroll', function () {
      if (dd.open && Math.abs(window.scrollY - dd.y) > 40) ddSet(null);
    }, { passive: true });
    window.addEventListener('resize', function () { if (dd.open) { if (!mqDesk.matches) ddSet(null); else ddTop(); } });

    /* Sepet ikonunun yaninda PDPAOLA gibi sayi */
    function addCount() {
      document.querySelectorAll('.header__cart-link a').forEach(function (a) {
        if (a.querySelector('.mgpd-count')) return;
        var src = document.querySelector('cart-count');
        var c = document.createElement('cart-count');
        c.className = 'mgpd-count';
        c.textContent = src ? src.textContent.trim() : '0';
        a.appendChild(c);
      });
    }

    function syncCount(n) {
      document.querySelectorAll('.mgpd-count').forEach(function (c) { if (c.textContent !== n) c.textContent = n; });
    }

    /* Sepet cekmecesi: urun sayisi, sepeti bosalt, kargo satiri, sepeti goruntule */
    function decorateBasket() {
      var d = document.querySelector('cart-drawer');
      if (!d) return;
      drawerMedia(d);
      var empty = d.querySelector('p.h5.text-center');
      if (empty && !d.querySelector('.cart-drawer__items') && !d.querySelector('.mgpd-empty-cta')) {
        var cta = document.createElement('a');
        cta.className = 'mgpd-empty-cta';
        cta.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'collections/new-in';
        cta.textContent = (i18n && i18n.shop) || 'Alışverişe devam et';
        empty.parentNode.insertBefore(cta, empty.nextSibling);
      }
      var items = d.querySelector('.cart-drawer__items');
      if (items && !d.querySelector('.mgpd-basket-meta')) {
        var t = document.getElementById('mgpd-basket-tpl');
        if (t) items.parentNode.insertBefore(t.content.cloneNode(true), items);
      }
      var meta = d.querySelector('.mgpd-basket-meta__count');
      if (meta) {
        var n = 0;
        d.querySelectorAll('.quantity-selector__input').forEach(function (i) { n += parseInt(i.value, 10) || 0; });
        var label = (n === 1 ? meta.dataset.one : meta.dataset.many).replace('[n]', n);
        if (meta.textContent !== label) meta.textContent = label;
        syncCount(String(n));
      }
      var total = d.querySelector('.muffgem-cart-total');
      if (total && !d.querySelector('.mgpd-basket-ship')) {
        var f = document.getElementById('mgpd-basket-foot-tpl');
        if (f) total.parentNode.insertBefore(f.content.cloneNode(true), total.nextSibling);
      }
      var group = d.querySelector('.cart-drawer__footer .button-group');
      if (group && !d.querySelector('.mgpd-basket-view')) {
        var v = document.getElementById('mgpd-basket-view-tpl');
        if (v) group.parentNode.insertBefore(v.content.cloneNode(true), group.nextSibling);
      }
    }

    /* Footer basliklari: PDPAOLA gibi yalnizca bas harfler buyuk */
    function titleCase() {
      document.querySelectorAll('.shopify-section--footer .footer .h6').forEach(function (h) {
        if (h.__mgpdTc) return;
        h.__mgpdTc = true;
        var loc = (document.documentElement.lang || 'tr').slice(0, 2).toLowerCase() === 'tr' ? 'tr-TR' : (document.documentElement.lang || 'en');
        var s = h.textContent.trim().toLocaleLowerCase(loc);
        h.textContent = s.replace(/(^|[\s&:\/-]+)(\S)/g, function (m, a, b) { return a + b.toLocaleUpperCase(loc); }).replace(/^Muffgem/, 'MUFFGEM');
      });
    }

    /* Urun adlari Ingilizce: Turkce buyuk harf donusumu ingilizce kelimelerde noktali I uretmesin (MEDALLION).
       Ad icindeki Turkce kelimeler (Bileklik, Ikili vb.) Turkce kurala gore kalir. */
    var TRW = /(Bileklikler|Bileklik|İkili|Sarmalı|Kelepçeler|Kelepçe|Şahmeranlar|Şahmeran|Küpeler|Küpe|Kolyeler|Kolye|Yüzükler|Yüzük|Serçe Parmak|Su Yolu)/g;
    function nameLang() {
      if ((document.documentElement.lang || 'tr').slice(0, 2).toLowerCase() !== 'tr') return;
      document.querySelectorAll('.mgpd-ccard__name, .mgpd-cell__name, .mgpd-cart__name, .mgpd-rcard__name, .mgpd-cols__name, .shopify-section--main-product .product-title, .product-sticky-bar .h6').forEach(function (el) {
        if (el.__mgL) return;
        el.__mgL = true;
        el.setAttribute('lang', 'en');
        var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), list = [], n;
        while ((n = w.nextNode())) { TRW.lastIndex = 0; if (TRW.test(n.textContent)) list.push(n); }
        list.forEach(function (t) {
          var f = document.createDocumentFragment(), txt = t.textContent, last = 0, m;
          TRW.lastIndex = 0;
          while ((m = TRW.exec(txt))) {
            if (m.index > last) f.appendChild(document.createTextNode(txt.slice(last, m.index)));
            var sp = document.createElement('span'); sp.setAttribute('lang', 'tr'); sp.textContent = m[0]; f.appendChild(sp);
            last = m.index + m[0].length;
          }
          if (last < txt.length) f.appendChild(document.createTextNode(txt.slice(last)));
          t.parentNode.replaceChild(f, t);
        });
      });
    }

    /* Sepete ekle sonrasi buton metni */
    var i18n = {};
    try { i18n = JSON.parse((document.getElementById('mgpd-chrome-i18n') || {}).textContent || '{}'); } catch (e) {}
    document.addEventListener('variant:add', function () {
      if (!on()) return;
      document.querySelectorAll('.shopify-section--main-product .product-info buy-buttons .button[type="submit"]').forEach(function (b) {
        if (b.__mgpdT) clearTimeout(b.__mgpdT);
        if (!b.dataset.mgpdLabel) b.dataset.mgpdLabel = b.textContent.trim();
        b.textContent = i18n.added || b.dataset.mgpdLabel;
        b.__mgpdT = setTimeout(function () { b.textContent = b.dataset.mgpdLabel; delete b.dataset.mgpdLabel; }, 2400);
      });
    });

    /* Urun gorselinin turunu algila:
       cut   = arka plani seffaf urun fotografi
       white = beyaz zeminli urun fotografi (multiply ile gri studyo degradesine karisir)
       scene = manken veya ortam fotografi (dokunulmaz)
       Urun fotograflarinda urunun kapladigi alan da olculur. Kutu kirpinca urun tasacaksa gorsel tam sigdirilir (mgpd-fit). */
    function tone(img) {
      try {
        var w = img.naturalWidth, h = img.naturalHeight;
        if (!w || !h) return null;
        var S = 48;
        var c = document.createElement('canvas');
        c.width = S; c.height = S;
        var x = c.getContext('2d', { willReadFrequently: true });
        x.drawImage(img, 0, 0, S, S);
        var d = x.getImageData(0, 0, S, S).data;
        var n = 0, tr = 0, wh = 0;
        function isWhite(j) {
          var mn = Math.min(d[j], d[j + 1], d[j + 2]), mx = Math.max(d[j], d[j + 1], d[j + 2]);
          return mn >= 236 && mx - mn < 16;
        }
        for (var yy = 0; yy < S; yy++) {
          for (var xx = 0; xx < S; xx++) {
            if (yy > 1 && yy < S - 2 && xx > 1 && xx < S - 2) continue;
            var j = (yy * S + xx) * 4;
            n++;
            if (d[j + 3] < 40) { tr++; continue; }
            if (isWhite(j)) wh++;
          }
        }
        var kind = 'scene';
        if (tr / n >= 0.6) kind = 'cut';
        else if (tr / n < 0.3 && wh / Math.max(1, n - tr) >= 0.8) kind = 'white';
        var box = null;
        if (kind !== 'scene') {
          var x0 = S, y0 = S, x1 = -1, y1 = -1;
          for (var py = 0; py < S; py++) {
            for (var px = 0; px < S; px++) {
              var k = (py * S + px) * 4;
              var fg = kind === 'cut' ? d[k + 3] >= 40 : !isWhite(k);
              if (!fg) continue;
              if (px < x0) x0 = px;
              if (px > x1) x1 = px;
              if (py < y0) y0 = py;
              if (py > y1) y1 = py;
            }
          }
          if (x1 >= 0) box = [x0 / S, y0 / S, (x1 + 1) / S, (y1 + 1) / S];
        }
        return { kind: kind, box: box, r: w / h };
      } catch (e) { return null; }
    }

    /* Kirpilinca urun kutudan tasar mi? object-fit cover ile gorunen alan hesaplanir. */
    function needsFit(img, t) {
      if (!t || !t.box) return false;
      var rc = img.getBoundingClientRect();
      if (!rc.width || !rc.height) return false;
      var A = rc.width / rc.height, r = t.r, m = 0.015;
      if (A < r) {
        var vw = A / r, a = 0.5 - vw / 2, b = 0.5 + vw / 2;
        return t.box[0] < a + m || t.box[2] > b - m;
      }
      var vh = r / A, c0 = 0.5 - vh / 2, c1 = 0.5 + vh / 2;
      return t.box[1] < c0 + m || t.box[3] > c1 - m;
    }

    function apply(img) {
      var t = img.__mgTone;
      if (!t) return;
      img.classList.toggle('mgpd-mult', t.kind === 'white');
      if (img.hasAttribute('data-mg-nofit')) return;
      img.classList.toggle('mgpd-fit', t.kind !== 'scene' && needsFit(img, t));
    }

    function mark(img) {
      if (img.__mgT && img.__mgSrc === img.currentSrc) return;
      var go = function () {
        img.__mgT = true;
        img.__mgSrc = img.currentSrc;
        var t = tone(img);
        if (!t) return;
        img.__mgTone = t;
        apply(img);
      };
      if (img.complete && img.naturalWidth) go();
      else img.addEventListener('load', go, { once: true });
    }

    var SEL = [
      '.shopify-section--main-product .product-gallery__media > img',
      '.mgpd-rcard__media > img',
      '.mgpd-ccard__slide > img',
      '.mgpd-cell__img',
      '.mgpd-cart__img',
      '.mgpd-li-media > img',
      '.mgpd-sres img'
    ].join(',');

    function scanImages() {
      document.querySelectorAll(SEL).forEach(mark);
    }
    window.__mgpdMark = function (img) { img.__mgT = false; mark(img); };

    var rz = null;
    window.addEventListener('resize', function () {
      clearTimeout(rz);
      rz = setTimeout(function () { document.querySelectorAll(SEL).forEach(function (i) { if (i.__mgTone) apply(i); }); }, 150);
    });

    /* Sepet cekmecesi gorselleri: gri studyo zemini ve keskin gorsel (ekran yogunluguna gore buyuk boyut) */
    function sharpen(img, px) {
      if (img.__mgHq) return;
      var src = img.getAttribute('src') || '';
      if (!src) return;
      img.__mgHq = true;
      var base = src.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
      var sep = base.indexOf('?') > -1 ? '&' : '?';
      img.setAttribute('srcset', [240, 360, 480, 600, 800].map(function (w) { return base + sep + 'width=' + w + ' ' + w + 'w'; }).join(', '));
      img.setAttribute('sizes', px + 'px');
    }

    function drawerMedia(d) {
      d.querySelectorAll('img.line-item__media').forEach(function (img) {
        if (!img.parentNode.classList.contains('mgpd-li-media')) {
          var s = document.createElement('span');
          s.className = 'mgpd-li-media';
          img.parentNode.insertBefore(s, img);
          s.appendChild(img);
        }
        sharpen(img, 180);
      });
    }

    /* Uygulama metinleri (urun secenekleri uygulamasi) EN ve RU sayfada Turkce kalmasin */
    var LG = (document.documentElement.lang || 'tr').slice(0, 2).toLowerCase();
    var APPTXT = {
      en: [['çift olarak satılmaktadır', 'All MuffGem earrings are sold as a pair.']],
      ru: [['çift olarak satılmaktadır', 'Все серьги MuffGem продаются парой.']]
    };
    var TONE = {
      tr: { 'gold': 'Altın tonu', 'silver': 'Gümüş tonu', 'rose': 'Rose tonu', 'rose gold': 'Rose tonu' },
      en: { 'gold': 'Gold tone', 'silver': 'Silver tone', 'rose': 'Rose tone', 'rose gold': 'Rose gold tone' },
      ru: { 'gold': 'Золотой тон', 'silver': 'Серебряный тон', 'rose': 'Розовый тон', 'rose gold': 'Розовое золото' }
    };
    function toneText() {
      var map = TONE[LG] || TONE.tr;
      document.querySelectorAll('cart-drawer .line-item p.smallcaps, cart-drawer .line-item-info p.smallcaps').forEach(function (el) {
        if (el.__mgTone === el.textContent || el.children.length) return;
        var parts = el.textContent.trim().split(' / ');
        var changed = false;
        parts = parts.map(function (x) { var k = x.toLowerCase(); if (map[k]) { changed = true; return map[k]; } return x; });
        if (changed) el.textContent = parts.join(' / ');
        el.__mgTone = el.textContent;
      });
    }
    function appText() {
      toneText();
      var list = APPTXT[LG];
      if (!list) return;
      document.querySelectorAll('.tpo_option-heading, .tpo_option-set-wrapper label, .tpo_option-set-wrapper p').forEach(function (el) {
        if (el.children.length) return;
        var tx = el.textContent || '';
        for (var i = 0; i < list.length; i++) {
          if (tx.indexOf(list[i][0]) > -1 && tx !== list[i][1]) { el.textContent = list[i][1]; break; }
        }
      });
    }

    /* Politika metinlerindeki sablon artiklarini, sokak adresini ve celiskili ifadeleri temizler (yalnizca gorunum) */
    function cleanPolicy(rte, here) {
      var h = rte.innerHTML, o = h;
      var root = (document.documentElement.lang || 'tr').slice(0, 2);
      var pre = root === 'tr' ? '' : '/' + root;
      var PP = pre + '/policies/privacy-policy', RP = pre + '/policies/refund-policy', TS = pre + '/policies/terms-of-service';
      var HY = 'Uluslararası hijyen kuralları nedeniyle küpe ve earcuff ürünlerinde iade ve değişim yapılamaz.';
      /* Hizmet sartlari: ikinci eski kopya kesilir, tum metni kalin yapan acik etiket duzeltilir */
      if (/terms-of-service/.test(here)) {
        var cut = h.indexOf('Bu web sitesi, MuffGem tarafından işletilmektedir.');
        if (cut > 2000 && h.indexOf('BÖLÜM 24') > -1 && h.indexOf('BÖLÜM 24') < cut) {
          h = h.slice(0, cut).replace(/(<br>\s*)*<\/strong>(\s*<br>)*\s*$/, '');
        }
        h = h.replace('<strong><strong>', '<strong>');
        h = h.replace(/\[SATICIYA NOT:[^\]]*\]\s*(<br>)?/g, '');
        h = h.replace('Gizlilik Politikamıza [LINK]', '<a href="' + PP + '">Gizlilik Politikamıza</a>')
          .replace('İade Politikamız [LINK]', '<a href="' + RP + '">İade Politikamız</a>')
          .replace('[LINK] üzerinden görüntülenebilecek Gizlilik Politikamıza', '<a href="' + PP + '">Gizlilik Politikamıza</a>')
          .replace('Gizlilik Politikamızı [LINK]', '<a href="' + PP + '">Gizlilik Politikamızı</a>')
          .replace(/\[İADE POLİTİKASI BAĞLANTISI\]/g, '<a href="' + RP + '">İade Politikası</a>')
          .replace(/\[GİZLİLİK POLİTİKASI BAĞLANTISI\]/g, '<a href="' + PP + '">Gizlilik Politikası</a>')
          .replace(/\s*\[LINK\]/g, '');
      }
      /* Sokak adresi ve eski telefon gosterilmez */
      h = h.replace(/\s*(ya da şu adresten bizimle iletişime geçin:|or contact us at:?|или свяжитесь с нами по (почтовому )?адресу:?)\s*(MuffGem,\s*)?Kapalıçarşı[^<]*?(TR|Türkiye|Turkey|Турция)\./g, '.')
        .replace(/(Dönsev Akca|Hamidiye mah\. Hamidiye cad\. no:19)(&nbsp;|\s)*(<br>)?/g, '')
        .replace(/\+90 542 746 37 71/g, '+90 551 816 03 45');
      /* Yasal bildirim: taslak yer tutucular */
      h = h.replace('[“Gizlilik Politikası” veya “KVKK Aydınlatma Metni”]', '<a href="' + PP + '">Gizlilik Politikası</a>')
        .replace('[“İade/Değişim Politikası”]', '<a href="' + RP + '">İade ve Değişim Politikası</a>')
        .replace('İstanbul (veya şirket merkezinin bulunduğu il/ilçe) Mahkemeleri', 'İstanbul Mahkemeleri')
        .replace('ve varsa “Hizmet Şartları” veya “Kullanım Koşulları” metninde', 've <a href="' + TS + '">Hizmet Şartları</a> metninde');
      /* Iade politikasi: urun sayfasiyla ayni hijyen cumlesi, ayarlanabilir yuzuklerle celisen ifade kaldirilir */
      h = h.replace('• Küpe ve earcuff gibi ürünler hijyenik nedenlerle iade ve değişim kapsamına dahil değildir.', '• ' + HY)
        .replace('• Hijyenik ürünler (küpe, earcuff vb.) iade ve değişim kapsamı dışındadır.', '• ' + HY)
        .replace(/<p>\s*• İthal yüzük siparişleri[^<]*<\/p>/, '')
        .replace('• Ölçü veya kişiselleştirme gerektiren ürünlerde (örneğin parmak ölçüsüne göre ayarlanan yüzükler, boyu/uzunluğu özel belirlenen kolye-bileklikler, harf/isim/gravür eklenen tasarımlar, sipariş üzerine özel yapılan parçalar)', '• Kişiye özel hazırlanan ürünlerde (örneğin harf, isim veya gravür eklenen tasarımlar ve sipariş üzerine özel yapılan parçalar)')
        .replace('• Ölçü veya kişiselleştirme gerektiren ürünler (yüzük ölçüsü, özel uzunluk, gravür vb.) iade/değişim kapsamı dışındadır.', '• Kişiye özel hazırlanan ürünler (harf, isim veya gravür eklenen tasarımlar) iade ve değişim kapsamı dışındadır.')
        .replace(/Ürünün kullanılıp kullanılmadığı aşağıdaki cihaz ve yöntemlerle objektif şekilde tespit edilir:[\s\S]*?görünür hâle getirilir\./, 'Her iade, kalite ekibimiz tarafından büyüteç ve özel ışık altında tek tek incelenir. Çizik, aşınma veya kullanım kaynaklı kalıntılar bu incelemede objektif olarak tespit edilir.')
        .replace('ortalama 3–5 iş günü', 'ortalama 3-5 iş günü');
      /* Iletisim: yanit suresi */
      if (/contact-information/.test(here) && h.indexOf('24') === -1) {
        h += '<p>' + ({ en: 'Our team replies within 24 hours on average.', ru: 'Наша команда отвечает в среднем в течение 24 часов.' }[root] || 'Ekibimiz mesajlarınıza ortalama 24 saat içinde dönüş yapar.') + '</p>';
      }
      /* Kargo politikasi: satir basi tireler */
      h = h.replace(/(&nbsp;|\u00a0)+–\s*/g, '');
      if (h !== o) rte.innerHTML = h;
    }

    /* Politika sayfasini sol menulu duzene alir */
    function policyLayout() {
      var tpl = document.getElementById('mgpd-polnav-tpl');
      var src = document.querySelector('.shopify-policy__container');
      if (!tpl || !src || src.classList.contains('mgpd-pol-src')) return;
      var h = src.querySelector('.shopify-policy__title h1, .shopify-policy__title');
      var body = src.querySelector('.shopify-policy__body');
      if (!body) return;
      var wrap = document.createElement('div');
      wrap.className = 'mgpd-pol';
      var side = document.createElement('aside');
      side.className = 'mgpd-pol__side';
      var h1 = document.createElement('h1');
      h1.className = 'mgpd-pol__title';
      h1.textContent = h ? h.textContent.trim() : document.title;
      var nav = document.createElement('nav');
      nav.className = 'mgpd-pol__nav';
      nav.appendChild(tpl.content.cloneNode(true));
      var here = location.pathname.replace(/\/$/, '');
      nav.querySelectorAll('a').forEach(function (a) {
        var u = (a.getAttribute('href') || '').split('?')[0].replace(/\/$/, '');
        if (u && here.slice(-u.length) === u) { a.classList.add('is-active'); a.setAttribute('aria-current', 'page'); }
      });
      side.appendChild(h1);
      if (nav.querySelector('a')) side.appendChild(nav);
      var main = document.createElement('div');
      main.className = 'mgpd-pol__main';
      var rte = document.createElement('div');
      rte.className = 'mgpd-pol__rte';
      while (body.firstChild) rte.appendChild(body.firstChild);
      cleanPolicy(rte, here);
      main.appendChild(rte);
      wrap.appendChild(side);
      wrap.appendChild(main);
      src.classList.add('mgpd-pol-src');
      src.parentNode.insertBefore(wrap, src);
      var act = nav.querySelector('a.is-active');
      if (act && nav.scrollWidth > nav.clientWidth) nav.scrollLeft = Math.max(0, act.offsetLeft - 15);
    }

    /* Metin icindeki e-posta ve telefonlari tiklanir yapar, basliktaki uzun tireyi sadelestirir */
    function linkify() {
      document.querySelectorAll('.mgpd-pol__rte, .mgpd-page__rte').forEach(function (root) {
        if (root.__mgLk) return;
        root.__mgLk = true;
        root.querySelectorAll('a:not([href])').forEach(function (a) {
          var tx = a.textContent.trim();
          if (/^[^@\s]+@[^@\s]+\.[a-z]{2,}$/i.test(tx)) { a.setAttribute('href', 'mailto:' + tx); a.classList.add('mgpd-mail'); }
        });
        var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
        var nodes = [], n;
        while ((n = walker.nextNode())) {
          if (n.parentElement && n.parentElement.closest('a')) continue;
          if (/[^@\s]+@[^@\s]+\.[a-z]{2,}|0\s?5\d{2}\s?\d{3}\s?\d{2}\s?\d{2}| — /i.test(n.textContent)) nodes.push(n);
        }
        nodes.forEach(function (node) {
          var html = node.textContent.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
            .replace(/ — /g, ': ')
            .replace(/([A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,})/g, '<a class="mgpd-mail" href="mailto:$1">$1</a>')
            .replace(/(0\s?5(\d{2})\s?(\d{3})\s?(\d{2})\s?(\d{2}))/g, function (m, all, a, b, c, d) { return '<a class="mgpd-mail" href="https://wa.me/905' + a + b + c + d + '" target="_blank" rel="noopener">' + all + '</a>'; });
          var span = document.createElement('span');
          span.innerHTML = html;
          node.parentNode.replaceChild(span, node);
        });
      });
    }

    var t = null;
    function run() {
      if (!on()) return;
      scanImages();
      injectMenu();
      injectDnav();
      addCount();
      decorateBasket();
      titleCase();
      appText();
      policyLayout();
      linkify();
      nameLang();
    }
    function later() { clearTimeout(t); t = setTimeout(run, 60); }

    function init() {
      run();
      if (window.MutationObserver) new MutationObserver(later).observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('cart:change', later);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mgpd-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function clean() {
      document.querySelectorAll('[data-mgpd-rte]').forEach(function (rte) {
        if (rte.__mgc) return;
        rte.__mgc = true;
        if (rte.innerHTML.indexOf('\uD83D\uDCA1') > -1) rte.innerHTML = rte.innerHTML.replace(/\uD83D\uDCA1\s?/g, '');
      });
    }

    function faq() {
      clean();
      document.querySelectorAll('.mgpd-page--faq [data-mgpd-rte]').forEach(function (rte) {
        if (rte.__mg) return;
        rte.__mg = true;
        rte.querySelectorAll('h1, h2, h3').forEach(function (h) {
          if (/s[ıi]k[çc]a sorulan/i.test(h.textContent)) h.remove();
        });
        rte.querySelectorAll('table').forEach(function (t) {
          var rows = t.querySelectorAll('tbody tr');
          if (!rows.length) return;
          var box = document.createElement('div');
          box.className = 'mgpd-faq';
          rows.forEach(function (r, i) {
            var c = r.querySelectorAll('td');
            if (c.length < 2) return;
            var d = document.createElement('details');
            d.className = 'mgpd-faq__item';
            var s = document.createElement('summary');
            s.textContent = c[0].textContent.replace(/^\s*\d+\.\s*/, '').trim();
            var a = document.createElement('div');
            a.className = 'mgpd-faq__a';
            a.innerHTML = c[1].innerHTML;
            d.appendChild(s);
            d.appendChild(a);
            box.appendChild(d);
          });
          var top = t.closest('[class*="_tableContainer"]') || t.closest('.table-scroller') || t;
          top.parentNode.replaceChild(box, top);
        });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', faq);
    else faq();
    document.addEventListener('shopify:section:load', faq);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mgpd-pdp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mgpdPdpJs) return;
    window.__mgpdPdpJs = true;

    var MAP = {
      'gold': '#d8b56d', 'altın': '#d8b56d', 'altin': '#d8b56d', 'altın tonu': '#d8b56d',
      'silver': '#c9c9c9', 'gümüş': '#c9c9c9', 'gumus': '#c9c9c9', 'gümüş tonu': '#c9c9c9',
      'rose': '#e2b7a6', 'rose gold': '#e2b7a6', 'rose tonu': '#e2b7a6',
      'yeşil': '#2f6d52', 'yesil': '#2f6d52', 'green': '#2f6d52',
      'kırmızı': '#a3202d', 'kirmizi': '#a3202d', 'red': '#a3202d',
      'mavi': '#2a4c8f', 'blue': '#2a4c8f', 'lacivert': '#1f2d55', 'navy': '#1f2d55',
      'siyah': '#111111', 'black': '#111111', 'beyaz': '#f2f2f2', 'white': '#f2f2f2',
      'pembe': '#e7a3b5', 'pink': '#e7a3b5', 'mor': '#6c4b98', 'purple': '#6c4b98',
      'turuncu': '#e08a3c', 'orange': '#e08a3c', 'şampanya': '#e6d3a8', 'champagne': '#e6d3a8'
    };
    MAP['gold shine'] = '#e6c77e'; MAP['silver bright'] = '#dedede'; MAP['bordo'] = '#6d1a2a'; MAP['fuşya'] = '#c2185b';
    MAP['kahverengi'] = '#7a4a2a'; MAP['brown'] = '#7a4a2a'; MAP['turkuaz'] = '#2bb0ad'; MAP['beyaz'] = '#f4f4f2';
    var LG = (document.documentElement.lang || 'tr').slice(0, 2).toLowerCase();
    var NAMES = {
      tr: { 'gold': 'Altın tonu', 'silver': 'Gümüş tonu', 'rose': 'Rose tonu', 'rose gold': 'Rose tonu', 'gold shine': 'Parlak altın tonu', 'silver bright': 'Parlak gümüş tonu' },
      en: { 'gold': 'Gold tone', 'silver': 'Silver tone', 'rose': 'Rose tone', 'rose gold': 'Rose gold tone', 'gold shine': 'Bright gold tone', 'silver bright': 'Bright silver tone' },
      ru: { 'gold': 'Золотой тон', 'silver': 'Серебряный тон', 'rose': 'Розовый тон', 'rose gold': 'Розовое золото', 'gold shine': 'Яркий золотой тон', 'silver bright': 'Яркий серебряный тон' }
    };
    var NAME = NAMES[LG] || NAMES.tr;

    function vdata() {
      var s = document.getElementById('mgpd-vmedia');
      if (!s) return null;
      if (s.__d) return s.__d;
      try { s.__d = JSON.parse(s.textContent); } catch (e) { s.__d = null; }
      return s.__d;
    }

    function focusMedia(mid) {
      var d = vdata();
      if (!d || !mid) return;
      mid = String(mid);
      document.querySelectorAll('.shopify-section--main-product product-gallery .product-gallery__media[data-media-id]').forEach(function (c) {
        var id = c.getAttribute('data-media-id');
        var first = id === mid;
        var g = d.grp && d.grp[id];
        var other = !first && (d.ids.indexOf(id) > -1 || (g && g !== mid));
        if (c.classList.contains('mgpd-vfirst') !== first) c.classList.toggle('mgpd-vfirst', first);
        if (c.classList.contains('mgpd-vother') !== other) c.classList.toggle('mgpd-vother', other);
      });
    }

    var curMedia = null;
    document.addEventListener('variant:change', function (e) {
      var v = e.detail && e.detail.variant;
      if (v && v.featured_media) {
        curMedia = v.featured_media.id;
        focusMedia(curMedia);
      }
    });

    function low(s) { return (s || '').trim().toLocaleLowerCase('tr-TR'); }

    function swatches() {
      if (!document.querySelector('.mgpd-pdp')) return;
      document.querySelectorAll('.shopify-section--main-product variant-picker').forEach(function (v) {
        [v, v.closest('.product-info__block-item')].forEach(function (el) {
          if (el && el.style.getPropertyPriority('display') !== 'important') el.style.setProperty('display', 'block', 'important');
        });
      });
      document.querySelectorAll('.shopify-section--main-product .variant-picker__option').forEach(function (fs) {
        var labels = Array.prototype.slice.call(fs.querySelectorAll('.block-swatch'));
        if (!labels.length) return;
        var vals = labels.map(function (l) { return low(l.textContent); });
        var legend = low((fs.querySelector('legend') || {}).textContent);
        var known = vals.every(function (v) { return MAP[v]; });
        if (!/renk|color|colour|metal|ton/.test(legend) && !known) return;
        if (!fs.classList.contains('mgpd-swatches')) fs.classList.add('mgpd-swatches');
        labels.forEach(function (l, i) {
          if (MAP[vals[i]] && l.style.getPropertyValue('--sw') !== MAP[vals[i]]) l.style.setProperty('--sw', MAP[vals[i]]);
          if (!l.title) l.title = l.textContent.trim();
        });
        var nm = fs.querySelector('.mgpd-sw-name');
        if (!nm) {
          nm = document.createElement('p');
          nm.className = 'mgpd-sw-name';
          fs.insertBefore(nm, fs.firstChild);
        }
        var checked = fs.querySelector('input:checked + .block-swatch');
        var v = checked ? checked.textContent.trim() : '';
        var txt = NAME[low(v)] || v;
        if (nm.textContent !== txt) nm.textContent = txt;
      });
    }

    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-mgpd-tab]');
      if (!b) return;
      var wrap = b.closest('.mgpd-tabs');
      if (!wrap) return;
      var open = b.getAttribute('aria-selected') === 'true';
      wrap.querySelectorAll('[data-mgpd-tab]').forEach(function (x) { x.setAttribute('aria-selected', 'false'); });
      wrap.querySelectorAll('[data-mgpd-panel]').forEach(function (p) { p.hidden = true; });
      if (!open) {
        b.setAttribute('aria-selected', 'true');
        var p = wrap.querySelector('[data-mgpd-panel="' + b.getAttribute('data-mgpd-tab') + '"]');
        if (p) p.hidden = false;
      }
    });

    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('variant-picker')) setTimeout(swatches, 30);
    });

    var t = null;
    function later() { clearTimeout(t); t = setTimeout(function () { swatches(); focusMedia(curMedia || (vdata() || {}).sel); }, 80); }
    function init() {
      swatches();
      focusMedia((vdata() || {}).sel);
      if (window.MutationObserver) new MutationObserver(later).observe(document.body, { childList: true, subtree: true });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mgpd-recs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function load(el) {
      if (!el || el.__mgpdLoaded || !el.dataset.url) return;
      el.__mgpdLoaded = true;
      fetch(el.dataset.url)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('.mgpd-recs');
          if (fresh && fresh.querySelector('.mgpd-rcard')) {
            el.innerHTML = fresh.innerHTML;
            el.removeAttribute('data-url');
          }
        })
        .catch(function () {});
    }

    function init(root) {
      (root || document).querySelectorAll('.mgpd-recs[data-url]').forEach(load);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
